import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';

class RadioButtonGroup extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.onChange(this.props.name,  event.target.value);
  }

  render() {

    const separator = this.props.vertical ? <br /> : '';
    const valueKey = this.props.valueKey;
    const labelKey = this.props.labelKey;

    return (
      <Fragment>
        {this.props.options && this.props.options.length > 0 &&
          this.props.options.map((item, index) => (
            <label key={index}>
              <input
                type="radio"
                name={this.props.name}
                value={item[valueKey]}
                checked={(this.props.selected == item[valueKey])}
                onChange={this.handleChange} />
              <span>{item[labelKey]}</span>
              {separator}
            </label>
          ))}
      </Fragment>
    );
  }
}

RadioButtonGroup.defaultProps = {
  labelKey: "name",
  valueKey: "id",
  options: [],
  vertical: false
};

RadioButtonGroup.propTypes = {
  name: PropTypes.string.isRequired,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
  options: PropTypes.array.isRequired,
  selected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

export default RadioButtonGroup;



// WEBPACK FOOTER //
// ./src/components/form/controls/RadioButtonGroup.js